//
// Generated class EventItemLine
//

/// <reference path="EventItemLine_ManagedObject.ts" />

class EventItemLine extends EventItemLine_ManagedObject
{

}
